import type { UseQueryResult } from '@tanstack/react-query';

import { useQuery } from '@tanstack/react-query';

import type { InstructorsFilterOptions } from '../../api/get-instructors-filter-options/getInstructorsFilterOptions.types';

import { getInstructorsFilterOptions } from '../../api/get-instructors-filter-options/getInstructorsFilterOptions';

export function useInstructorsFilterOptions(
  customerId: string
): UseQueryResult<InstructorsFilterOptions, Error> {
  return useQuery<InstructorsFilterOptions, Error>({
    queryKey: ['instructors', 'filters', customerId],
    queryFn: (): Promise<InstructorsFilterOptions> =>
      getInstructorsFilterOptions(customerId),
    enabled: !!customerId,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
